import React, { useEffect, useState } from "react";
import {
  Form,
  Button,
  Table,
  Container,
  Row,
  Col,
  Modal,
  Spinner,
  Pagination,
  ModalFooter,
} from "react-bootstrap";
import "../../css/admin/adminDashboard.css";
import { apiPost } from "../../service/admin/apiService";
import { showSuccess, showError } from "../../utils/toast";
import AdminScreenHeader from "../admin/adminScreenHeader";
import Loader from "../loader";
import { FaEdit } from "react-icons/fa";
import {
  BsPlus,
  BsX,
  BsSend,
  BsCheck,
  BsFileCheck,
  BsList,
} from "react-icons/bs";
import Form24QTable from "../client/form24QTable";
import Form26QTable from "../client/form26QTable";
import Form27EQTable from "../client/form27EQTable";
import FormGSTR1Table from "../client/formGSTR1Table";
import FormGSTR7Table from "../client/formGSTR7Table";
import ExportToExceljs from "../../utils/exportToExcel";

const ReviewClientData = () => {
  const [clientDataToReview, setClientDataToReview] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [reviewloading, setReviewLoading] = useState(false);
  const [allowClientLoading, setAllowClientLoading] = useState(false);
  const [limit, setLimit] = useState(10);
  const [activePage, setActivePage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [selectedFormInfo, setSelectedFormInfo] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedForm, setSelectedForm] = useState("");
  const [selectedFYearId, setSelectedFYearId] = useState(0);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedClientId, setSelectedClientId] = useState(0);
  const [selectedClientName, setSelectedClientName] = useState("");
  const [selectedClientTan, setSelectedClientTan] = useState("");
  const [selectedFinancialYear, setSelectedFinancialyear] = useState("");
  const tk = localStorage.getItem("tk") || "";

  useEffect(() => {
    getFormsToReview();
  }, []);

  useEffect(() => {
    if (selectedFormInfo.length > 0) {
      setShowModal(true);
    }
  }, [selectedFormInfo]);

  const filteredClientData = clientDataToReview.filter((clientData) => {
    const fullName = `${clientData.na} ${clientData.ta}`.toLowerCase();
    const term = searchTerm.toLowerCase();
    return (
      clientData.na.toLowerCase().includes(term) ||
      clientData.ta.toLowerCase().includes(term) ||
      fullName.includes(term)
    );
  });

  useEffect(() => {
    const calculatedMaxPage = Math.ceil(filteredClientData.length / limit) || 1;
    setMaxPage(calculatedMaxPage);
    if (activePage > calculatedMaxPage) setActivePage(1);
  }, [filteredClientData, limit]);

  const getFormsToReview = async () => {
    setShowLoader(true);
    const payload = {
      action: "getcadashboard",
      to: tk,
    };

    try {
      const response = await apiPost(process.env.REACT_APP_API_URL, payload);
      console.log("clients", response?.responsedetails);
      if (Number(response?.errordetails?.errorcode) > 0) {
        showError(response?.errordetails?.error);
      } else if (response?.responsedetails) {
        if (response?.responsedetails?.forms) {
          setClientDataToReview(response?.responsedetails.forms || []);
          setTimeout(() => {
            setShowLoader(false);
          }, 3000);
        }
      }
    } catch (err) {
      setShowLoader(false);
      console.error("Error fetching client data to review", err);
    }
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > maxPage) return;
    setActivePage(pageNumber);
  };

  const getFormInfo = async (frm, fid, mn, clid, cna, cta, fina) => {
    setShowLoader(true);
    const payload = {
      action: "formlist",
      to: tk,
      ty: frm,
      fi: fid,
      mn: mn,
      clid: clid,
    };

    try {
      const response = await apiPost(process.env.REACT_APP_API_URL, payload);

      if (Number(response?.errordetails?.errorcode) > 0) {
        showError(response?.errordetails?.error);
        setShowLoader(false);
      } else if (response?.responsedetails) {
        console.log("response form", response?.responsedetails, frm);
        setSelectedForm(frm);
        setSelectedFYearId(fid);
        setSelectedMonth(mn);
        setSelectedClientId(clid);
        setSelectedClientName(cna);
        setSelectedClientTan(cta);
        setSelectedFinancialyear(fina);
        setSelectedFormInfo(response?.responsedetails);

        setTimeout(() => {
          setShowLoader(false);
        }, 2000);
      }
    } catch (err) {
      console.error("Error:", err);
      showError("Something went wrong");
      setShowLoader(false);
    } finally {
      setShowLoader(false);
    }
  };

  const manageAction = async (actType) => {
    if (reviewloading || allowClientLoading) return;
    if (actType === "review") {
      setReviewLoading(true);
    } else {
      setAllowClientLoading(true);
    }

    const payload = {
      action: "formsubmit",
      to: tk,
      ty: selectedForm,
      fi: selectedFYearId,
      mn: selectedMonth,
      cid: selectedClientId,
      ...(actType === "review" ? { su: "yes", ae: "" } : { ae: "yes", su: "" }),
    };

    console.log("payload action", payload);

    try {
      const response = await apiPost(process.env.REACT_APP_API_URL, payload);

      if (Number(response?.errordetails?.errorcode) > 0) {
        showError(response?.errordetails?.error);
        if (actType === "review") {
          setReviewLoading(false);
        } else {
          setAllowClientLoading(false);
        }
      } else if (response?.responsedetails) {
        console.log("response56565", response?.responsedetails);
        if (response?.responsedetails?.success === "yes") {
          setTimeout(() => {
            if (actType === "review") {
              setReviewLoading(false);
              showSuccess(
                "Selected info is now reviewed and marked as completed"
              );
            } else {
              setAllowClientLoading(false);
              showSuccess("Selected info is now unfreezed for client to edit");
            }
            setShowModal(false);
            getFormsToReview();
          }, 3000);
        }
      }
    } catch (err) {
      console.error("Error:", err);
      showError("Something went wrong");
      if (actType === "review") {
        setReviewLoading(false);
      } else {
        setAllowClientLoading(false);
      }
    }
  };

  return (
    <Container className="mt-4 ">
      {/* Desktop View */}
      <div className="d-none d-md-block mt-3">
        <AdminScreenHeader
          title="📋 Client Data"
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          placeholder="Search Client/Tan"
          showSearch={true}
        />

        <div
          className="fixed-table"
          style={{ maxHeight: "500px", overflowY: "auto" }}
        >
          <Table
            striped
            bordered
            hover
            responsive
            className="w-100 custom-table text-primary"
            style={{ verticalAlign: "middle" }}
          >
            <thead>
              <tr>
                <th style={{ width: "35%" }}>Client Name</th>
                <th style={{ width: "25%" }}>Tan No.</th>
                <th style={{ textAlign: "center", width: "10%" }}>Mobile</th>
                <th style={{ textAlign: "center", width: "10%" }}>Form Name</th>
                <th style={{ textAlign: "center", width: "10%" }}>
                  Financial Year
                </th>
                <th style={{ textAlign: "center", width: "5%" }}>Month</th>
                <th style={{ textAlign: "center", width: "5%" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredClientData
                .slice((activePage - 1) * limit, activePage * limit)
                .map((clientData, index) => (
                  <tr key={index}>
                    <td>{clientData.na}</td>
                    <td>{clientData.ta}</td>
                    <td style={{ textAlign: "center" }}>{clientData.m1}</td>
                    <td style={{ textAlign: "center" }}>{clientData.fn}</td>
                    <td style={{ textAlign: "center" }}>{clientData.fina}</td>
                    <td style={{ textAlign: "center" }}>{clientData.mo}</td>
                    <td style={{ textAlign: "center" }}>
                      <Button
                        variant="link"
                        onClick={() =>
                          getFormInfo(
                            clientData.fn,
                            clientData.fid,
                            clientData.mo,
                            clientData.id,
                            clientData.na,
                            clientData.ta,
                            clientData.fina
                          )
                        }
                      >
                        <FaEdit
                          style={{ cursor: "pointer", color: "#2c3e50" }}
                        />
                      </Button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </div>
        <Row className="mt-3 mb-3">
          <Col className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <label
                className="me-2 mb-0"
                style={{ color: "#0d6efd", fontSize: "13px" }}
              >
                Records per page:
              </label>
              <Form.Select
                value={limit}
                onChange={(e) => {
                  const value =
                    e.target.value === "All"
                      ? filteredClientData.length
                      : parseInt(e.target.value);
                  setLimit(value);
                  setActivePage(1);
                }}
                style={{ width: "100px" }}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100000">All</option>
              </Form.Select>
            </div>

            {/* Pagination */}
            <Pagination className="mb-0">
              <Pagination.First
                onClick={() => handlePageChange(1)}
                disabled={activePage === 1}
              />
              <Pagination.Prev
                onClick={() => handlePageChange(activePage - 1)}
                disabled={activePage === 1}
              />
              <Pagination.Item>
                {`Page ${activePage} of ${maxPage}`}
              </Pagination.Item>
              <Pagination.Next
                onClick={() => handlePageChange(activePage + 1)}
                disabled={activePage >= maxPage}
              />
              <Pagination.Last
                onClick={() => handlePageChange(maxPage)}
                disabled={activePage >= maxPage}
              />
            </Pagination>
          </Col>
        </Row>
      </div>

      <Modal
        size="xl"
        show={showModal}
        onHide={() => {
          setShowModal(false);
          setSelectedFormInfo([]);
        }}
        // dialogClassName="modal-90w"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {/* <div>{selectedClientName}</div>
            <div style={{ fontSize: "12px" }}>
              Financial Year: {selectedFinancialYear}
            </div>
            <div style={{ fontSize: "12px" }}>Month: {selectedMonth}</div>
            <div style={{ fontSize: "12px" }}>Tan: {selectedClientTan},</div>
            <div style={{ fontSize: "12px" }}>Form: {selectedForm}</div> */}
            <table>
              <tr
                style={{
                  fontSize: "18px",
                  width: "150px",
                  whiteSpace: "nowrap",
                }}
              >
                <td>{selectedClientName}</td>
              </tr>
              <tr>
                <td
                  style={{
                    fontSize: "12px",
                    width: "85px",
                    whiteSpace: "nowrap",
                  }}
                >
                  Financial Year
                </td>
                <td style={{ fontSize: "12px" }}>{selectedFinancialYear}</td>
              </tr>
              <tr>
                <td
                  style={{
                    fontSize: "12px",
                    width: "85px",
                    whiteSpace: "nowrap",
                  }}
                >
                  Month
                </td>
                <td style={{ fontSize: "12px" }}>{selectedMonth}</td>
              </tr>
              <tr>
                <td
                  style={{
                    fontSize: "12px",
                    width: "85px",
                    whiteSpace: "nowrap",
                  }}
                >
                  Tan
                </td>
                <td style={{ fontSize: "12px" }}>{selectedClientTan}</td>
              </tr>
              <tr>
                <td
                  style={{
                    fontSize: "12px",
                    width: "85px",
                    whiteSpace: "nowrap",
                  }}
                >
                  Form
                </td>
                <td style={{ fontSize: "12px" }}>{selectedForm}</td>
              </tr>
            </table>
          </Modal.Title>
        </Modal.Header>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "-10px",
            marginTop: "5px",
            paddingRight: "15px",
          }}
        >
          <ExportToExceljs
            data={selectedFormInfo}
            fileName="ClientDataToReview"
            formName={selectedForm}
            clientName={selectedClientName}
            clientTan={selectedClientTan}
            financialYear={selectedFinancialYear}
            month={selectedMonth}
          />
        </div>
        <Modal.Body style={{ maxHeight: "100vh", overflowY: "auto" }}>
          <div className="table-container">
            {selectedFormInfo ? (
              selectedForm === "form24q" ? (
                <Form24QTable
                  data={selectedFormInfo}
                  activePage={1}
                  limit={10000}
                />
              ) : selectedForm === "form26q" ? (
                <Form26QTable
                  data={selectedFormInfo}
                  activePage={1}
                  limit={10000}
                />
              ) : selectedForm === "form27eq" ? (
                <Form27EQTable
                  data={selectedFormInfo}
                  activePage={1}
                  limit={10000}
                />
              ) : selectedForm === "formgstr1" ? (
                <FormGSTR1Table
                  data={selectedFormInfo}
                  activePage={1}
                  limit={10000}
                />
              ) : selectedForm === "formgstr7" ? (
                <FormGSTR7Table
                  data={selectedFormInfo}
                  activePage={1}
                  limit={10000}
                />
              ) : null
            ) : (
              <div className="text-center py-5">
                <Spinner animation="border" />
              </div>
            )}
          </div>
        </Modal.Body>
        <ModalFooter>
          <div className="d-flex flex-column flex-md-row justify-content-between mb-2 mt-3 gap-2">
            <div className="align-self-start"></div>
            <div className="d-flex flex-column flex-md-row gap-2">
              <Button
                className="btn-primary-submit-to-ca w-100 w-md-auto text-nowrap"
                onClick={() => {
                  manageAction("review");
                }}
              >
                {reviewloading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Set Reviewed
                  </>
                ) : (
                  <>
                    <BsFileCheck
                      className="me-2"
                      style={{ fontSize: "1.3rem" }}
                    />
                    Set Reviewed
                  </>
                )}
              </Button>
              <Button
                className="w-100 w-md-auto text-nowrap"
                onClick={() => {
                  manageAction("allowEdit");
                }}
              >
                {allowClientLoading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Allow Client To Edit
                  </>
                ) : (
                  <>
                    <BsList className="me-2" style={{ fontSize: "1.3rem" }} />
                    Allow Client To Edit
                  </>
                )}
              </Button>

              <Button
                className="w-100 w-md-auto text-nowrap"
                onClick={() => {
                  setSelectedForm("");
                  setShowModal(false);
                }}
              >
                <BsX
                  className="me-2"
                  style={{ color: "red", fontSize: "1.5rem" }}
                />
                Close
              </Button>
            </div>
          </div>
        </ModalFooter>
      </Modal>

      {showLoader ? <Loader show={showLoader} /> : null}
    </Container>
  );
};

export default ReviewClientData;
